import { inject } from '@angular/core';
import { NavigationService } from 'app/@core/navigation/navigation.service';
import { NotificationsService } from 'app/layout/common/notifications/notifications.service';
import { take } from 'rxjs';

export const initialDataResolver = () => {
    const navigationService      = inject(NavigationService);
    const notificationsService   = inject(NotificationsService);

    notificationsService.startListening();

    return navigationService.navigation$.pipe(take(1));
};
